import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircleIcon, XIcon } from "lucide-react";
const NAMES = ["María José", "Lucía", "Gastón", "Sofía", "Martín", "Valentina", "Julián", "Carla", "Federico", "Agustina", "Rodrigo", "Florencia", "Diego", "Camila"];
const CITIES = ["Buenos Aires", "Córdoba", "Rosario", "Mendoza", "La Plata", "Mar del Plata", "San Miguel de Tucumán", "Salta", "Santa Fe", "Neuquén", "Bahía Blanca", "Paraná"];
function rand<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
interface PopupData {
  name: string;
  city: string;
  minutes: number;
}
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState<PopupData>({
    name: NAMES[0],
    city: CITIES[0],
    minutes: 3
  });
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    const show = () => {
      setData({
        name: rand(NAMES),
        city: rand(CITIES),
        minutes: Math.floor(Math.random() * 12) + 1
      });
      setVisible(true);
      timeoutId = setTimeout(() => setVisible(false), 5000);
    };
    const firstDelay = setTimeout(show, 4000);
    const interval = setInterval(show, 15000);
    return () => {
      clearTimeout(firstDelay);
      clearTimeout(timeoutId);
      clearInterval(interval);
    };
  }, []);
  return <div className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex justify-center px-4" data-id="element-139" data-mp="n8y5ac5o0vd4">
      <AnimatePresence data-id="element-140" data-mp="iaelahamttne">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.35
      }} className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-2xl border border-sand bg-cream px-4 py-3 shadow-xl" role="status" data-id="element-141" data-mp="x6c9ndebdtp2">
            <CheckCircleIcon className="h-8 w-8 shrink-0 text-italian-green" aria-hidden="true" data-id="element-142" data-mp="2ap2yx4lqeg8j" />
            <div className="flex-1 text-[13px] leading-snug text-ink" data-id="element-143" data-mp="2fm34zfikzizn">
              <span className="font-bold" data-id="element-144" data-mp="2kmhgx8nazd2y">
                {data.name} de {data.city}
              </span>{" "}
              acaba de comprar el libro digital
              <span className="block text-[11px] text-ink/60" data-id="element-145" data-mp="2pjhlff4i87ry">
                hace {data.minutes} min · Compra verificada ✅
              </span>
            </div>
            <button type="button" onClick={() => setVisible(false)} aria-label="Cerrar notificación" className="shrink-0 text-ink/40 hover:text-ink" data-id="element-146" data-mp="1wxofwxrtqf1h">
              <XIcon className="h-4 w-4" data-id="element-147" data-mp="26p2lnnadcb32" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}